import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_getInstance29j9s2wnmk34z as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMethod.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { KtMutableList1beimitadwkna as KtMutableList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_DecompressionListAttribute() {
  _init_properties_HeadersUtils_kt__fb6dxx();
  return DecompressionListAttribute;
}
var DecompressionListAttribute;
function dropCompressionHeaders(_this__u8e3s4, method, attributes, alwaysRemove) {
  alwaysRemove = alwaysRemove === VOID ? false : alwaysRemove;
  _init_properties_HeadersUtils_kt__fb6dxx();
  if (method.equals(Companion_getInstance().Head_1) || method.equals(Companion_getInstance().Options_1))
    return Unit_instance;
  var header = _this__u8e3s4.get_6bo4tg_k$('Content-Encoding');
  if (header == null) {
    if (!alwaysRemove)
      return Unit_instance;
  } else {
    var tmp = get_DecompressionListAttribute();
    attributes.computeIfAbsent_c4qp5i_k$(tmp, dropCompressionHeaders$lambda).add_utx5q5_k$(header);
  }
  _this__u8e3s4.remove_6241ba_k$('Content-Encoding');
  _this__u8e3s4.remove_6241ba_k$('Content-Length');
}
function dropCompressionHeaders$lambda() {
  _init_properties_HeadersUtils_kt__fb6dxx();
  // Inline function 'kotlin.collections.mutableListOf' call
  return ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
}
var properties_initialized_HeadersUtils_kt_8c3zal;
function _init_properties_HeadersUtils_kt__fb6dxx() {
  if (!properties_initialized_HeadersUtils_kt_8c3zal) {
    properties_initialized_HeadersUtils_kt_8c3zal = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'DecompressionListAttribute';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(KtMutableList());
    var tmp_0 = !(null == null) ? isInterface(null, KtMutableList()) : false;
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(getKClass(KtMutableList()), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false))]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new (TypeInfo())(tmp, tmp_0, tmp$ret$2);
    DecompressionListAttribute = new (AttributeKey())(name, tmp$ret$1);
  }
}
//region block: exports
export {
  dropCompressionHeaders as dropCompressionHeaders12falb2m2fkr1,
};
//endregion

//# sourceMappingURL=HeadersUtils.mjs.map
